import { GetDailyCheckInByIdResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getDailyCheckInById } from '../../services'
import { DailyCheckInQueryKeys } from '@/modules/promotion/keys'

export default function useQueryGetDailyCheckInById(
	id: string,
	props?: UseBaseQueryOptions<GetDailyCheckInByIdResponse>,
) {
	return useQuery({
		queryKey: [DailyCheckInQueryKeys.GetDailyCheckInById, id],
		queryFn: () => getDailyCheckInById(id),
		...props,
	})
}
